import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckIcon, MinusIcon } from 'assets/icons';
import classNames from 'classnames';
import { Typography } from 'modules/ui';

import styles from './AttachmentSentStatusPill.module.scss';

export interface IAttachmentSentStatusPillProps {
    sent: boolean;
    size?: 'big' | 'small';
    /** Wording of the two states; defaults to "sent" / "not sent". */
    labels?: { sent: string; notSent: string };
}

export const AttachmentSentStatusPill: React.FC<IAttachmentSentStatusPillProps> = ({ sent, size = 'big', labels }) => {
    const { t } = useTranslation();
    const text = labels ?? { sent: t('attachments.mail.sent'), notSent: t('attachments.mail.notSent') };

    return (
        <div
            className={classNames(styles.pillWrapper, {
                [styles.sent]: sent,
                [styles.small]: size === 'small',
            })}
        >
            {sent ? (
                <>
                    <CheckIcon className={styles.checkIcon} strokeWidth={2} />
                    <Typography className={styles.sentText} fontWeight="medium" variant="p">
                        {text.sent}
                    </Typography>
                </>
            ) : (
                <>
                    <MinusIcon className={styles.minusIcon} />
                    <Typography fontWeight="medium" color="secondary" variant="p">
                        {text.notSent}
                    </Typography>
                </>
            )}
        </div>
    );
};
